<template lang="pug">
.vgt_online-menu
  .l-container
    ul
      li
        nuxt-link(to="/vgt2020") VGT@ONLINEトップ
      li
        nuxt-link(to="/vgt2020/archives") 配信アーカイブ
      li
        nuxt-link(to="/vgt_speaker") スピーカー
      li.pc |
      li.pc
        a(href="https://www.youtube.com/channel/UCwQ0VT8WWOT5Nvcg5Q43zxA" target="_blank")
          sns-youtube-svg
          strong Vook YouTubeチャンネル
      li.pc
        a(href="https://twitter.com/VookJp" target="_blank")
          sns-twitter-svg
          strong @VookJp（Twitter）

</template>

<script>
import SnsYoutubeSvg from '~/assets/images/svg/sns_youtube.svg?inline'
import SnsTwitterSvg from '~/assets/images/svg/sns_twitter.svg?inline'
export default {
  components: {
    SnsYoutubeSvg,
    SnsTwitterSvg
  }
}
</script>
